import React from 'react';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from './ui/carousel';
import { Card } from './ui/card';
import { clientLogos, extraGalleryData } from '../data/mockData';
import Autoplay from 'embla-carousel-autoplay';

export const Clients = () => {
  const autoplay = React.useRef(
    Autoplay({ delay: 3000, stopOnInteraction: false })
  );

  return (
    <section id="clients" className="py-16 bg-gradient-to-br from-gray-50 to-pink-50">
      <div className="container mx-auto px-6">
        {/* Title */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Marcas que já Cultivam Conexões
          </h2>
          <p className="text-lg text-gray-600">
            Plantinha de Geladeira, o presente perfeito para todas as ocasiões.
          </p>
        </div>

        {/* Extra Image Carousel (entre subtítulo e logos) */}
        <div className="max-w-6xl mx-auto mb-14">
          <Carousel
            opts={{
              align: "start",
              loop: false,
              startIndex: 0,
            }}
            className="w-full"
          >
            <CarouselContent className="-ml-2 md:-ml-4">
              {extraGalleryData.map((item, index) => (
                <CarouselItem key={index} className="pl-2 md:pl-4 md:basis-1/2 lg:basis-1/3">
                  <Card className="border-pink-100 overflow-hidden group">
                    <div className="relative aspect-square overflow-hidden bg-gray-100">
                      <img
                        src={item.image}
                        alt={item.title}
                        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-gray-900/80 via-gray-900/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                        <div className="absolute bottom-0 left-0 right-0 p-6 text-white transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300">
                          <h3 className="text-xl font-bold mb-2">{item.title}</h3>
                          <p className="text-sm text-gray-200">{item.description}</p>
                        </div>
                      </div>
                    </div>
                    <div className="p-4 md:hidden bg-white">
                      <h3 className="text-lg font-bold text-gray-900 mb-1">{item.title}</h3>
                      <p className="text-sm text-gray-600">{item.description}</p>
                    </div>
                  </Card>
                </CarouselItem>
              ))}
            </CarouselContent>
            <CarouselPrevious className="hidden md:flex -left-12 bg-white border-2 border-[#eb068c] text-[#eb068c] hover:bg-pink-50" />
            <CarouselNext className="hidden md:flex -right-12 bg-white border-2 border-[#eb068c] text-[#eb068c] hover:bg-pink-50" />
          </Carousel>
        </div>

        {/* Logos Carousel */}
        <div className="max-w-6xl mx-auto">
          <Carousel
            plugins={[autoplay.current]}
            opts={{
              align: "center",
              loop: true,
            }}
            className="w-full"
            onMouseEnter={() => autoplay.current.stop()}
            onMouseLeave={() => autoplay.current.play()}
          >
            <CarouselContent className="-ml-4">
              {clientLogos.map((client, index) => (
                <CarouselItem key={index} className="pl-4 md:basis-1/3 lg:basis-1/4">
                  <div className="bg-white rounded-2xl p-10 flex items-center justify-center shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1 border border-pink-100 h-[180px]">
                    <img 
                      src={client.logo}
                      alt={client.name}
                      className={`max-w-full h-auto object-contain opacity-80 hover:opacity-100 transition-all duration-300 grayscale hover:grayscale-0 ${
                        client.name === "RENASE Eventos" || client.name === "Chave Ideal" || client.name === "Globo"
                          ? "max-h-40" 
                          : "max-h-32"
                      }`}
                    />
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>

            {/* Navigation - Hidden on mobile */}
            <CarouselPrevious className="hidden md:flex -left-12 bg-white border-2 border-[#eb068c] text-[#eb068c] hover:bg-pink-50" />
            <CarouselNext className="hidden md:flex -right-12 bg-white border-2 border-[#eb068c] text-[#eb068c] hover:bg-pink-50" />
          </Carousel>
        </div>
      </div>
    </section>
  );
};
